import { Link } from 'react-router-dom';
import { EntityImage } from '@urbanx/agx-ui-components';
import { AgentDetails, Team, TeamMember } from '@urbanx/agx.agencies.client';
import { AgxAvatarGroup, AgxColumn, AgxTypography } from '@urbanx/agx.ui-components2';
import { tokens } from '@urbanx/agx.ui-components2/tokens';

import './TeamDisplay.scss';

interface TeamDisplayProps {
  team: Team;
  to: string;
  agents: AgentDetails[];
  adminManagerName?: string;
}

const sortMembersByPhoto = (a: TeamMember, b: TeamMember, agents: AgentDetails[]) => {
  const agentA = agents.find((agent) => agent.id === a.agentId);
  const agentB = agents.find((agent) => agent.id === b.agentId);

  const hasPhotoA = !!agentA?.photo?.publicPath;
  const hasPhotoB = !!agentB?.photo?.publicPath;

  return hasPhotoA === hasPhotoB ? 0 : hasPhotoA ? -1 : 1;
};

const TeamDisplay = ({ team, to, agents, adminManagerName }: TeamDisplayProps) => {
  const adminManagerLabel = team.adminManagerId
    ? (adminManagerName ?? team.adminManagerId)
    : 'Agency default';
  const sortedTeamMemberAvatars =
    (team.members ?? [])
      .toSorted((a, b) => sortMembersByPhoto(a, b, agents))
      .map((m) => {
        const agent = agents.find((agent) => agent.id === m.agentId);
        return agent?.photo?.publicPath ?? agent?.firstName ?? '';
      }) ?? [];

  return (
    <Link to={to} className="teamDisplay">
      <AgxColumn gap={'spacing-xl'} padding={'spacing-3xl'}>
        <div className="teamAvatar">
          {team.photoUri ? (
            <img src={team.photoUri ?? ''} className="teamAvatarImg"></img>
          ) : (
            <EntityImage
              addRingToImage={false}
              name={team.name}
              size={72}
              backgroundColour={'rgba(0,0,0,0)'}
            />
          )}
        </div>
        <AgxColumn gap="spacing-xs">
          <AgxTypography id={'teamName'} type={'body'} size={'large'}>
            {team.name}
          </AgxTypography>
          <AgxTypography
            id={`teamAdminManager-${team.id}`}
            type="caption"
            size="medium"
            color={tokens.text.tertiary}
          >
            {`Admin Manager: ${adminManagerLabel}`}
          </AgxTypography>
        </AgxColumn>
        <AgxAvatarGroup size="medium" avatars={sortedTeamMemberAvatars} />
      </AgxColumn>
    </Link>
  );
};

export default TeamDisplay;
